import React from "react";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {EditElementModalForm} from "../EditElementModalForm";
import {APIClient} from "../../utils/APIClient";
import {GoalConfiguration} from "../business_units/global_info/GoalConfiguration";
import { withTranslation } from 'react-i18next';

class EditGoalFormComponent extends EditElementModalForm {

    constructor(props) {
        super(props);
        this.state = {
            clientName: null,
            businessUnitName: null,
            campaignName: null,
            adgroupName: null,
            hasGoal: null,
            value: null,
            metricName: null,
            metricConversionConfiguration: null,
            loading: true,
            saving: false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    _isEditingCampaign() {
        return this.props.campaignsConfigurationId !== undefined
            && this.props.campaignsConfigurationId !== null
            && this.props.campaignId !== undefined
            && this.props.campaignId !== null;
    }

    _isEditingAdgroup() {
        return this.props.campaignsConfigurationId !== undefined
            && this.props.campaignsConfigurationId !== null
            && this.props.adgroupId !== undefined
            && this.props.adgroupId !== null;
    }

    componentDidMount() {
        if(this._isEditingCampaign())
            this.getCampaignGoalData();
        else if(this._isEditingAdgroup())
            this.getAdgroupGoalData();
        else
            this.getBusinessUnitGoalData();

    }

    getBusinessUnitGoalData() {
        new APIClient(this.getUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    clientName: response.data.client_name,
                    businessUnitName: response.data.business_unit_name,
                    hasGoal: response.data.has_goal,
                    metricName: response.data.metric_name,
                    metricConversionConfiguration: response.data.metric_conversion_configuration,
                    value: response.data.value,
                    loading: false
                });
            }
        })
    }

    getCampaignGoalData() {
        new APIClient(this.getCampaignUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    clientName: response.data.client_name,
                    businessUnitName: response.data.business_unit_name,
                    campaignName: response.data.campaign_name,
                    hasGoal: response.data.has_goal,
                    metricName: response.data.metric_name,
                    metricConversionConfiguration: response.data.metric_conversion_configuration,
                    value: response.data.value,
                    loading: false
                });
            }
        })
    }

    getAdgroupGoalData() {
        new APIClient(this.getAdgroupUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    clientName: response.data.client_name,
                    businessUnitName: response.data.business_unit_name,
                    campaignName: response.data.campaign_name,
                    adgroupName: response.data.adgroup_name,
                    hasGoal: response.data.has_goal,
                    metricName: response.data.metric_name,
                    metricConversionConfiguration: response.data.metric_conversion_configuration,
                    value: response.data.value,
                    loading: false
                });
            }
        })
    }

    handleChange(data) {
        if(data === null || data === undefined) {
            this.setState({
                hasGoal: false,
                value: null,
                metricName: null,
                metricConversionConfiguration: null
            });
        } else {
            this.setState({
                hasGoal: true,
                value: data["value"],
                metricName: data["metricName"],
                metricConversionConfiguration: data["metricConversionConfiguration"] !== undefined ? data["metricConversionConfiguration"] : null
            });
        }
    }

    getUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/goals/${this.props.priority}`;
    }

    getCampaignUrl() {
        return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/campaigns/${this.props.campaignId}/goals/${this.props.priority}`;
    }

    getAdgroupUrl() {
        return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/adgroups/${this.props.adgroupId}/goals/${this.props.priority}`;
    }

    getSubmitUrl() {
        if(this._isEditingCampaign())
            return this.getCampaignUrl()
        else if(this._isEditingAdgroup())
            return this.getAdgroupUrl()
        else
            return  this.getUrl()
    }

    getDataToSubmit(event) {
        return {
            'has_goal': this.state.hasGoal,
            'metric_name': this.state.metricName,
            'value': this.state.value,
            'metric_conversion_configuration': this.state.metricConversionConfiguration
        };
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            const { t } = this.props;
            return <input type="submit" value={t('client.save_button')} className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    renderFormFields() {
        if (this.state.loading === true) {
            return <Spinner color="positive small"/>;
        }

        let data = null;
        if(this.state.hasGoal) {
            data = {
                "metricName": this.state.metricName,
                "value": this.state.value,
                "metricConversionConfiguration": this.state.metricConversionConfiguration
            }
        }

        return <div className="modal-section">
            <div className="row mb-3 pb-0">
                <div className="col-6">
                    <label>Cliente</label>
                    <input name="client" type="text" value={this.state.clientName} readOnly="readonly"
                           className="form-control"/>
                </div>
                {this.renderBusinessUnitName()}
            </div>
            {this.renderCampaignAndAdgroupNameRow()}
            <div className="row">
                <GoalConfiguration priority={this.props.priority}
                                   data={data}
                                   onChange={this.handleChange}
                                   businessUnitId={this.props.businessUnitId}
                                   campaignsConfigurationId={this.props.campaignsConfigurationId}
                />
            </div>
        </div>;
    }

    renderBusinessUnitName() {
        if(!this.state.businessUnitName)
            return null;

        return <div className="col-6">
            <label>Línea de control</label>
            <input name="business_unit" type="text" value={this.state.businessUnitName} readOnly="readonly"
                   className="form-control"/>
        </div>;
    }

    renderCampaignAndAdgroupNameRow() {
        if(!this._isEditingCampaign() && !this._isEditingAdgroup())
            return null;

        let adgroupSection = "";
        if(this._isEditingAdgroup()) {
            adgroupSection = <div className="col-6">
                <label>Grupo de anuncios</label>
                <input name="adgroup" type="text" value={this.state.adgroupName} readOnly="readonly"
                       className="form-control"/>
            </div>
        }

        return <div className="form-row mb-3 pb-0">
            <div className="col-6">
                <label>Campaña</label>
                <input name="campaign" type="text" value={this.state.campaignName} readOnly="readonly" className="form-control"/>
            </div>
            {adgroupSection}
        </div>
    }
}

export const EditGoalForm = withTranslation()(EditGoalFormComponent);
